import React from "react";
import { Box, Typography } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PropTypes from "prop-types";
import useDeviceType from "hooks/useDeviceType";
import colors from "app/theme/base/colors";

export default function ProgramDateSelector({ startDate, endDate, onChange }) {
  const { isLaptop } = useDeviceType();

  const labelFont = isLaptop ? "0.65rem" : "0.75rem";
  const inputFont = isLaptop ? "0.8rem" : "0.9rem";
  const height = isLaptop ? "38px" : "46px";

  // 🔥 Fecha de hoy en formato YYYY-MM-DD
  const today = new Date().toISOString().split("T")[0];

  function DateField({ label, field, value }) {
    const minDate = field === "startDate" ? today : startDate || today;

    return (
      <Box
        sx={{
          flex: "1 1 160px",
          borderRadius: "10px",
          backgroundColor: "grey.100",
          border: "1px solid",
          borderColor: "grey.300",
          px: 1.5,
          py: 1,
          height,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          transition: "all .15s ease",
          "&:hover": { backgroundColor: "grey.200", borderColor: "primary.main" },
        }}
      >
        <Typography
          sx={{
            fontSize: labelFont,
            fontWeight: 600,
            color: "text.secondary",
            ml: "2px",
            lineHeight: 1,
          }}
        >
          {label}
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.3,
            mt: "2px",
          }}
        >
          <CalendarMonthIcon sx={{ fontSize: isLaptop ? 16 : 18, color: "text.secondary" }} />

          <input
            type="date"
            value={value || ""}
            min={minDate}
            max="2100-12-31"
            onChange={(e) => {
              const newValue = e.target.value;

              // Permitir borrar
              if (!newValue) {
                onChange(field, "");
                return;
              }

              // Evitar fechas pasadas
              if (newValue < today) return;

              // Evitar endDate < startDate
              if (field === "endDate" && startDate && newValue < startDate) {
                return;
              }

              onChange(field, newValue);
            }}
            style={{
              flex: 1,
              border: "none",
              outline: "none",
              background: "transparent",
              fontSize: inputFont,
              fontWeight: 600,
              color: colors.text.primary,
              cursor: "pointer",
            }}
          />
        </Box>
      </Box>
    );
  }

  DateField.propTypes = {
    label: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired,
    value: PropTypes.string,
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "16px",
        width: "100%",
      }}
    >
      <DateField label="Desde" field="startDate" value={startDate} />
      <DateField label="Hasta" field="endDate" value={endDate} />
    </Box>
  );
}

ProgramDateSelector.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
